import {Injectable} from '@angular/core';

@Injectable()
export class WerteConverterUtil {


  getWindrichtungByDegree(degree: number) {
    let richtung;
    if (degree < 22.5 && degree >= 337.5) {
      richtung = 'N';
    } else if (degree < 67.5 && degree >= 22.5) {
      richtung = 'NO';
    } else if (degree < 125.5 && degree >= 67.5) {
      richtung = 'O';
    } else if (degree < 157.5 && degree >= 125.5) {
      richtung = 'SO';
    } else if (degree < 202.5 && degree >= 157.5) {
      richtung = 'S';
    } else if (degree < 247.5 && degree >= 202.5) {
      richtung = 'SW';
    } else if (degree < 292.5 && degree >= 247.5) {
      richtung = 'W';
    } else if (degree < 337.5 && degree >= 292.5) {
      richtung = 'NW';
    } else if (degree < 22.5 && degree >= 0) {
      richtung = 'N';
    }
    return richtung;
  }

  getWindrichtungsIconByText(text: string) {
    switch (text) {
      case 'N':
        return 'south';
      case 'O':
        return 'west';
      case 'S':
        return 'north';
      case 'W':
        return 'east';
      case 'NO':
        return 'south_west';
      case 'NNO':
        return 'south_west';
      case 'NW':
        return 'south_east';
      case 'NNW':
        return 'south_east';
      case 'SO':
        return 'north_west';
      case 'SSO':
        return 'north_west';
      case 'SW':
        return 'north_east';
      case 'SSW':
        return 'north_east';
      case 'WNW':
        return 'south_east';
      case 'WSW':
        return 'north_east';
      case 'OSO':
        return 'north_west';
      case 'ONO':
        return 'south_west';
      case 'NNO':
        return 'south_west';
      default:
        return text;
    }
  }

  getWindrichtungsIcon(degree: number) {
    let windrichtung = this.getWindrichtungByDegree(degree);
    switch (windrichtung) {
      case 'N':
        return 'south';
      case 'O':
        return 'west';
      case 'S':
        return 'north';
      case 'W':
        return 'east';
      case 'NO':
        return 'south_west';
      case 'NW':
        return 'south_east';
      case 'SO':
        return 'north_west';
      case 'SW':
        return 'north_east';
      default:
        return windrichtung;
    }
  }

  convertToQuadratmeter(einheit: string) {
    return einheit != null && einheit !== undefined ? einheit.replace('^2', '²') : '';
  }

  convertDecimalWithComma(messwert: number) {
    return messwert != null ? Math.round(Number.parseInt(messwert.toString().replace('.', ','))).toString() : '';
  }
}
